<template>
    <div class="page">
        <van-nav-bar
                title="跟团游报价"
                left-text="返回"
                left-arrow
                fixed
                placeholder
                @click-left="onClickLeft"
        />
        <div class="content-box">
            <!-- 出发日期选择 -->
            <div class="date-section">
                <van-field
                        v-model="departureDate"
                        label="出发日期"
                        placeholder="请选择出发日期"
                        readonly
                        is-link
                        required
                        @click="showDatePicker = true"
                />
                <van-popup v-model="showDatePicker" position="bottom">
                    <van-datetime-picker
                            v-model="currentDate"
                            type="date"
                            :min-date="minDate"
                            :max-date="maxDate"
                            @confirm="onDateConfirm"
                            @cancel="showDatePicker = false"
                    />
                </van-popup>
            </div>

            <!-- 获取报价按钮 -->
            <div class="btn-section">
                <van-button type="primary" block round :loading="quoting" @click="onGetQuote">获取报价</van-button>
            </div>

            <!-- 报价信息展示 -->
            <div class="quote-section" v-if="quoteInfo">
                <div class="quote-card">
                    <div class="quote-item">
                        <div class="quote-main">
                            <span class="label">成人价</span>
                            <span class="price">¥{{ quoteInfo.adultPrice }}</span>
                        </div>
                        <div class="quote-sub">
                            <span class="profit">利润 ¥{{ quoteInfo.adultProfit }}</span>
                            <span class="cost">成本 ¥{{ quoteInfo.adultCost }}</span>
                            <span class="base">底价 ¥{{ quoteInfo.adultBasePrice }}</span>
                        </div>
                    </div>
                    <div class="quote-item">
                        <div class="quote-main">
                            <span class="label">儿童价</span>
                            <span class="price">¥{{ quoteInfo.childPrice }}</span>
                        </div>
                        <div class="quote-sub">
                            <span class="profit">利润 ¥{{ quoteInfo.childProfit }}</span>
                            <span class="cost">成本 ¥{{ quoteInfo.childCost }}</span>
                            <span class="base">底价 ¥{{ quoteInfo.childBasePrice }}</span>
                        </div>
                    </div>
                    <div class="quote-item">
                        <div class="quote-main">
                            <span class="label">单房差</span>
                            <span class="price">¥{{ quoteInfo.singleRoomDiff }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {NavBar, Field, Popup, DatetimePicker, Button} from 'vant';
    import {akGroupTourQuote} from '@/api/groupTour';

    export default {
        name: "groupTourDetail",
        components: {
            [NavBar.name]: NavBar,
            [Field.name]: Field,
            [Popup.name]: Popup,
            [DatetimePicker.name]: DatetimePicker,
            [Button.name]: Button
        },
        data() {
            return {
                productId: null,
                departureDate: '',
                currentDate: new Date(),
                minDate: new Date(),
                maxDate: new Date(new Date().getFullYear() + 1, 11, 31),
                showDatePicker: false,
                quoting: false,
                quoteInfo: null
            };
        },
        created() {
            this.productId = this.$route.query.id
        },
        methods: {
            onClickLeft() {
                this.$router.go(-1)
            },
            onDateConfirm(value) {
                const year = value.getFullYear()
                const month = String(value.getMonth() + 1).padStart(2, '0')
                const day = String(value.getDate()).padStart(2, '0')
                this.departureDate = `${year}-${month}-${day}`
                this.currentDate = value
                this.showDatePicker = false
            },
            onGetQuote() {
                if (!this.departureDate) {
                    this.$toast('请先选择出发日期')
                    return
                }
                if (!this.productId) {
                    this.$toast('产品ID缺失')
                    return
                }
                this.quoting = true
                this.quoteInfo = null
                akGroupTourQuote({
                    productId: this.productId,
                    travelDate: this.departureDate
                }).then(res => {
                    this.quoteInfo = res
                }).catch(err => {
                    // 错误信息已由 request 拦截器 toast 提示
                }).finally(() => {
                    this.quoting = false
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .page {
        min-height: 100vh;
        background: #f5f7fa;
    }

    .content-box {
        padding: 16px;
    }

    .date-section {
        background: #fff;
        border-radius: 12px;
        overflow: hidden;
        margin-bottom: 16px;
    }

    .btn-section {
        margin-bottom: 20px;
    }

    .quote-section {
        .quote-card {
            background: #fff;
            border-radius: 12px;
            overflow: hidden;
            padding: 12px 16px;
        }

        .quote-item {
            padding: 12px 0;
            border-bottom: 1px solid #f0f0f0;

            &:last-child {
                border-bottom: none;
                padding-bottom: 0;
            }

            &:first-child {
                padding-top: 0;
            }
        }

        .quote-main {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 6px;

            .label {
                font-size: 16px;
                font-weight: bold;
                color: #333;
            }

            .price {
                font-size: 18px;
                font-weight: bold;
                color: #ff6b35;
            }
        }

        .quote-sub {
            margin-top: 8px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .profit {
                font-size: 12px;
                color: #409EFF;
            }

            .cost {
                font-size: 12px;
                color: #999;
            }

            .base {
                font-size: 12px;
                color: #67c23a;
            }
        }
    }
</style>
